import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, ModalBody } from '@chakra-ui/react';
import HeaderSideNav from '../HeaderSideNav';
import { containerItemStyle } from '../NavigationMenuMobile.style';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function DiscoverSideNav(_ref) {
  var _labels$subNav, _subNavItems$map;
  var onClickHeaderTitle = _ref.onClickHeaderTitle,
    labels = _ref.labels;
  var subNavItems = labels === null || labels === void 0 || (_labels$subNav = labels.subNav) === null || _labels$subNav === void 0 ? void 0 : _labels$subNav.filter(item => {
    var _item$title;
    return !(item !== null && item !== void 0 && (_item$title = item.title) !== null && _item$title !== void 0 && _item$title.includes('Business'));
  });
  return _jsxs(_Fragment, {
    children: [_jsx(HeaderSideNav, {
      title: labels.discoverPI,
      onClickTitle: onClickHeaderTitle
    }), _jsx(ModalBody, {
      p: "0",
      "data-testid": "discoverSideNav",
      children: _jsx(Flex, {
        flexDir: "column",
        children: subNavItems === null || subNavItems === void 0 || (_subNavItems$map = subNavItems.map) === null || _subNavItems$map === void 0 ? void 0 : _subNavItems$map.call(subNavItems, category => {
          return _createElement(Flex, _objectSpread(_objectSpread({}, customContainerItemStyle), {}, {
            key: "category-".concat(category.title)
          }), _jsx(Box, {
            children: category.title
          }), _jsx(Flex, {
            flexDir: "column",
            pl: "0.81rem",
            children: category.navOptions.map(option => {
              var _option$url;
              return _jsx(Box, {
                lineHeight: "2.5rem",
                children: _jsx("a", {
                  href: (_option$url = option.url) !== null && _option$url !== void 0 ? _option$url : '/',
                  children: option.title
                })
              }, option.title);
            })
          }));
        })
      })
    })]
  });
}
var customContainerItemStyle = _objectSpread(_objectSpread({}, containerItemStyle), {}, {
  flexDirection: 'column',
  ml: '0',
  pl: 'md',
  w: '100%'
});